module.exports = __webpack_public_path__ + "od-two-stars/od-two-stars-69b43f7013f7645b90169a32094d3799.png";